
import { defineComponent, reactive, ref, Ref } from "vue";
import { RequestKindTypes } from "@/models/request";
import RequestView from "@/components/common/Request/RequestView.vue";
import CancelConfirm from "@/components/common/Confirm/CancelConfirm";
import router from "@/router";
import { useI18n } from "vue-i18n";
import { RouterName } from "@/models/common";

export default defineComponent({
  name: "Online Care Request View",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      id: props.id,
      isQuick: false,
    });

    const { t } = useI18n();

    const cancel$: Ref<CancelConfirm | null> = ref(null);

    const CancelRequest = (requestKey: number) => {
      cancel$.value?.cancelConfirm(requestKey);
    };
    const CancelAccept = () => {
      console.log("CancelAccept=>", RouterName.ONLINE_CARE);
      //router.push(RouterName.ONLINE_CARE);
      router.push({ name: RouterName.ONLINE_CARE, path: "../onlinecare" });
    };

    const onDeletedFile = (fileKey: number) => {
      console.log("Deleted file with key:", fileKey);
    };

    return { state, RequestKindTypes, CancelRequest, CancelAccept, cancel$, t, onDeletedFile };
  },
  components: {
    RequestView,
  },
});
